export default "__VITE_ASSET__58dec53c__"